import type { Popup } from '@typeform/embed';

export default defineNuxtPlugin({
  name: 'typeform',
  parallel: true,
  async setup () {
    const [{ createPopover }] = await Promise.all([
      import('@typeform/embed'),
      import('@typeform/embed/build/css/popover.css')
    ]);

    const userState = useUserState();

    const typeformEmbedPopup = useState<Popup | null>('typeFormPopup', () => null);

    watch(userState, (newUserState) => {
      typeformEmbedPopup.value?.unmount();

      if (newUserState) {
        typeformEmbedPopup.value = createPopover('MiqF3XJb', {
          autoResize: '300, 700',
          height: '600',
          buttonColor: '#582dc1',
          hidden: {
            user_id: newUserState.sub,
            email: newUserState.email,
          },
        });
      } else {
        typeformEmbedPopup.value = createPopover('MiqF3XJb', {
          buttonColor: '#582dc1',
          autoResize: '300, 700',
          height: '600',
        });
      }
    }, { immediate: true });

    return {
      provide: {
        typeformEmbedPopup
      }
    };
  },
  hooks: {
    'app:mounted': () => {
      const { $typeformEmbedPopup } = useNuxtApp();

      const route = useRoute();

      watch(() => route.name, (newRouteName) => {
        if (newRouteName?.toString().includes('orders') || newRouteName?.toString().includes('register')) {
          $typeformEmbedPopup.value?.unmount();
        }
      }, { immediate: true });
    }
  }
});
